import React from 'react'
import Select, { components } from 'react-select'
import makeAnimated from 'react-select/animated'

const animatedComponents = makeAnimated()

const DropdownMulti = ({
  options,
  value,
  onChange,
  placeholder = '',
  className = '',
}) => {
  return (
    <Select
      closeMenuOnSelect={false}
      components={animatedComponents}
      isMulti
      options={options}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className={`dropdownMulti`}
      classNamePrefix="dropdownMulti"
    />
  )
}

export default DropdownMulti
